/* ============================================
   ELVARIS™ Clinical Skin Assessment Quiz
   Frontend-only — Zero cart/product interaction
   ============================================ */
(function() {
  'use strict';

  const quizContainer = document.getElementById('ev-quiz');
  if (!quizContainer) return;

  const steps = [
    {
      label: 'Step 1 of 4',
      question: "What's your primary skin concern?",
      options: ['Fine lines & wrinkles', 'Dullness & uneven tone', 'Loss of firmness', 'Rough texture & pores']
    },
    {
      label: 'Step 2 of 4',
      question: 'How would you describe your skin type?',
      options: ['Dry or dehydrated', 'Oily or acne-prone', 'Combination', 'Sensitive or reactive']
    },
    {
      label: 'Step 3 of 4',
      question: 'How long have you been using peptide-based skincare?',
      options: ["I'm completely new to peptides", 'Less than 6 months', '6 months to 1 year', 'Over 1 year']
    },
    {
      label: 'Step 4 of 4',
      question: 'What matters most in your skincare routine?',
      options: ['Clinically proven results', 'Clean, safe ingredients', 'Fast visible improvements', 'Simplicity — fewer products']
    }
  ];

  const results = {
    'Fine lines & wrinkles': {
      badge: 'Anti-Aging Focus',
      title: 'Your Skin Craves Regeneration',
      text: 'GHK-Cu copper peptides are clinically studied to support collagen production and reduce the appearance of fine lines. Elvaris™ Serum delivers targeted peptide therapy with hyaluronic acid for deep hydration — exactly what aging skin needs.'
    },
    'Dullness & uneven tone': {
      badge: 'Radiance Boost',
      title: 'Your Skin Needs a Brightness Reset',
      text: 'Copper peptides help promote cellular turnover and even out skin tone from within. Combined with niacinamide and hyaluronic acid, Elvaris™ Serum revitalizes dull skin for a natural, healthy glow.'
    },
    'Loss of firmness': {
      badge: 'Firming Protocol',
      title: 'Your Skin Is Ready for Peptide Therapy',
      text: 'GHK-Cu is one of the most researched peptides for skin firmness and elasticity. Elvaris™ Serum delivers clinical-grade copper peptides to help restore structure and support your skin\'s natural repair processes.'
    },
    'Rough texture & pores': {
      badge: 'Texture Refinement',
      title: 'Your Skin Deserves a Smoother Canvas',
      text: 'Copper peptides combined with hyaluronic acid work to refine skin texture and minimize the appearance of pores. Elvaris™ Serum provides the precision formulation your skin needs for a smoother, more refined complexion.'
    }
  };

  let currentStep = 0;
  let answers = [];

  function render() {
    const step = steps[currentStep];
    const progress = ((currentStep + 1) / steps.length) * 100;

    quizContainer.querySelector('.ev-quiz__progress-fill').style.width = progress + '%';

    const stepsEl = quizContainer.querySelectorAll('.ev-quiz__step');
    stepsEl.forEach(function(el) { el.classList.remove('active'); });

    const resultEl = quizContainer.querySelector('.ev-quiz__result');
    if (resultEl) resultEl.classList.remove('active');

    var stepEl = stepsEl[currentStep];
    if (stepEl) {
      stepEl.classList.add('active');
      var options = stepEl.querySelectorAll('.ev-quiz__option');
      options.forEach(function(opt, i) {
        opt.classList.toggle('selected', answers[currentStep] === i);
      });
    }
  }

  function showResult() {
    var concern = steps[0].options[answers[0]];
    var result = results[concern] || results['Fine lines & wrinkles'];

    quizContainer.querySelector('.ev-quiz__progress-fill').style.width = '100%';

    var stepsEl = quizContainer.querySelectorAll('.ev-quiz__step');
    stepsEl.forEach(function(el) { el.classList.remove('active'); });

    var resultEl = quizContainer.querySelector('.ev-quiz__result');
    resultEl.querySelector('.ev-quiz__result-badge').textContent = result.badge;
    resultEl.querySelector('.ev-quiz__result-title').textContent = result.title;
    resultEl.querySelector('.ev-quiz__result-text').textContent = result.text;
    resultEl.classList.add('active');
  }

  // Build quiz HTML
  var html = '<div class="ev-quiz__progress"><div class="ev-quiz__progress-fill" style="width:25%"></div></div>';
  html += '<div class="ev-quiz__body">';

  steps.forEach(function(step, si) {
    html += '<div class="ev-quiz__step' + (si === 0 ? ' active' : '') + '" data-step="' + si + '">';
    html += '<div class="ev-quiz__step-label">' + step.label + '</div>';
    html += '<h3 class="ev-quiz__question">' + step.question + '</h3>';
    html += '<div class="ev-quiz__options">';
    step.options.forEach(function(opt, oi) {
      html += '<div class="ev-quiz__option" data-step="' + si + '" data-option="' + oi + '">';
      html += '<span class="ev-quiz__option-radio"></span>';
      html += '<span>' + opt + '</span>';
      html += '</div>';
    });
    html += '</div>';
    html += '<div class="ev-quiz__nav">';
    if (si > 0) {
      html += '<button class="ev-quiz__btn ev-quiz__btn--back" data-action="back">Back</button>';
    }
    html += '<button class="ev-quiz__btn ev-quiz__btn--next" data-action="next" disabled>Continue</button>';
    html += '</div>';
    html += '</div>';
  });

  html += '<div class="ev-quiz__result">';
  html += '<div class="ev-quiz__result-badge"></div>';
  html += '<h3 class="ev-quiz__result-title"></h3>';
  html += '<p class="ev-quiz__result-text"></p>';
  html += '<button class="ev-quiz__result-cta" data-action="shop">View Recommended Product</button>';
  html += '</div>';

  html += '</div>';
  quizContainer.innerHTML = html;

  // Event delegation
  quizContainer.addEventListener('click', function(e) {
    var option = e.target.closest('.ev-quiz__option');
    if (option) {
      var si = parseInt(option.dataset.step);
      var oi = parseInt(option.dataset.option);
      answers[si] = oi;
      render();
      // Enable next button
      var stepEl = quizContainer.querySelectorAll('.ev-quiz__step')[si];
      var nextBtn = stepEl.querySelector('[data-action="next"]');
      if (nextBtn) nextBtn.disabled = false;
      return;
    }

    var btn = e.target.closest('[data-action]');
    if (!btn) return;

    var action = btn.dataset.action;
    if (action === 'next') {
      if (answers[currentStep] === undefined) return;
      if (currentStep < steps.length - 1) {
        currentStep++;
        render();
      } else {
        showResult();
      }
    } else if (action === 'back') {
      if (currentStep > 0) {
        currentStep--;
        render();
      }
    } else if (action === 'shop') {
      // Scroll to product section — NO cart manipulation
      var productSection = document.querySelector('[id*="product-information"], .product-information, [data-section-type="product"]');
      if (!productSection) {
        productSection = document.querySelector('.shopify-section--product, .product') || document.querySelector('main');
      }
      if (productSection) {
        productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.location.href = '/collections/all';
      }
    }
  });

  // Scroll reveal for elvaris sections
  var reveals = document.querySelectorAll('.ev-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function(el) { observer.observe(el); });
  }

  // FAQ accordion
  document.querySelectorAll('.ev-faq__question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.ev-faq__item');
      var wasOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.ev-faq__item').forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });

})();
